import * as React from 'react';
import './Loader.css';
import { connect } from 'react-redux';
import State from '../../application/core/State';
import Loader from './Loader';

interface Props {
    loader: boolean;
}

class AppLoader extends React.PureComponent<Props> {
    public render(): JSX.Element | null {
        return this.props.loader ? <Loader /> : null;
    }
}

const mapStateToProps = (state: State): Props => ({
    loader: state.application.loader
});

export default connect(mapStateToProps)(AppLoader);



// WEBPACK FOOTER //
// ./src/view/common/AppLoader.tsx